export default function modalSlideshow(key) {
  //console.log(key);
  return { type: "MODAL_SLIDESHOW", payload: key };
}
